import {BrowserRouter, useLocation, useNavigate, useRoutes} from 'react-router-dom';
import NavigationHeader from './components/Navigation/NavigationHeader';
import SideNavigationMenu from './components/Navigation/NavigationHeader.mobile';
import Footer from './components/Footer/Footer';
import React, {useEffect, useRef} from "react";
import useDeviceType from "./hooks/useDeviceType";
import {IntlProvider} from "react-intl";
import {messages} from "./i18n/i18n";

import './App.scss';
import {useDispatch, useSelector} from "react-redux";
import {selectLocale, selectUserIsAuthenticated} from "./stores/account/account.selectors";
import routesConfig from "./routesConfig";
import ModalWrapper from "./components/AppModal/ModalWrapper";
import BottomNavigationBar from "./components/Navigation/BottomNavigationBar";
import {useGetAccountQuery} from "./stores/account/account.api";
import {subToGroup} from "./services/hub/Connection";
import ResourceType from "./constants/ResourceType";
import pickXApi , {useIsGeoRestrictedQuery} from "./stores/pickX/pickX.api";
import GlobalConst from "./constants/GlobalConst";
import {setUtmDataFromQS} from "./services/UtmTracker";
import useAppModalService from "./hooks/useAppModalService";
import {useCloseModalsOnBrowserNav} from "./hooks/useCloseModalsOnBrowserNav";
//import {PrivyProvider} from '@privy-io/react-auth';

// eslint-disable-next-line import/no-unresolved
//import {toSolanaWalletConnectors} from '@privy-io/react-auth/solana';
const toSolanaWalletConnectors = () => []
const PrivyProvider = (props)=>{return <>{props.children}</>};

function AppRoutes() {
    const routing = useRoutes(routesConfig);
    return routing;
}

function App() {
    const { isDesktop } = useDeviceType();
    const locale = useSelector(selectLocale);
    const {data, isLoading} = useGetAccountQuery();

    useEffect(() => {
        if (!isLoading) {
            subToGroup(ResourceType.PICKX, "*");
        }
    }, [isLoading, data]);

    if (isLoading) {
        return <div>Loading...</div>;
    }


    return (
        <IntlProvider locale={locale} messages={messages[locale]}>
            <PrivyProvider
                appId={GlobalConst.PRIVY.AppId}
                clientId={GlobalConst.PRIVY.ClientId}
                config={{
                    appearance: {
                        theme: 'dark',
                        walletChainType: 'ethereum-and-solana',
                        walletList:  [
                            "detected_ethereum_wallets",

                            "phantom",
                            "solflare",
                            "backpack",
                            "wallet_connect_qr"
                        ],
                    },
                    embeddedWallets: {
                        /*ethereum: {
                            createOnLogin: 'users-without-wallets'
                        },
                        solana: {
                            createOnLogin: 'users-without-wallets',
                            connectors: toSolanaWalletConnectors()
                        }*/
                        ethereum: { createOnLogin: 'off' },
                        solana:   { createOnLogin: 'off' },
                    },
                    externalWallets: {
                        solana: { connectors: toSolanaWalletConnectors() },
                    },
                }}
            >
                <div className="App">
                    <BrowserRouter>
                        <ModalWrapper>
                                <AppInit />
                                {isDesktop ? <NavigationHeader />
                                           : <SideNavigationMenu />}

                                <main className="mainContent">
                                    <div className="container">
                                        <AppRoutes />
                                    </div>
                                </main>

                                {isDesktop ? <Footer />
                                           : <BottomNavigationBar />}
                        </ModalWrapper>
                    </BrowserRouter>
                </div>
            </PrivyProvider>
        </IntlProvider>
    );
}

const AppInit = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const userIsAuthenticated = useSelector(selectUserIsAuthenticated);
    const hasRedirected = useRef(false);
    const {data:isGeoRestricted} = useIsGeoRestrictedQuery({},{skip: !GlobalConst.FEATURES.GEOFENCE});
    const modalService = useAppModalService();

    useCloseModalsOnBrowserNav(modalService.closeAll);

    useEffect(() => {
        if (userIsAuthenticated && location.pathname === '/' && !hasRedirected.current) {
            navigate('/lobby');
            hasRedirected.current = true;
        }
    }, [userIsAuthenticated, location, navigate]);

    useEffect(() => {
        if(isGeoRestricted && location.pathname !== '/restricted'){
            navigate('/restricted');
        }
    }, [isGeoRestricted, navigate, location.pathname]);

    useEffect(() => {
        const pwd = new URLSearchParams(window.location.search).get('pwd');
        if(pwd){
            localStorage.setItem('password', pwd);
        }

        setUtmDataFromQS();
    }, []);

    useEffect(() => {
        const leagues = ['NFL', 'NBA', 'MLB', 'NHL', 'MLS', 'EPL', 'LMX'];
        const match = location.pathname.match(/^\/Picks\/([^/]+)\/NextAvailableP12$/);
        if (match) {
            const league = match[1];
            if (leagues.includes(league)) {
                (async () => {
                    try {
                        const result = await dispatch(
                            pickXApi.endpoints.getNextAvailableP12ByLeague.initiate(league, {forceRefetch: true})
                        ).unwrap();

                        if (result?.Id) {
                            navigate(`/lobby/Picks/${result.Id}`);
                        } else {
                            navigate('/lobby');
                        }
                    } catch (err) {
                        console.error("Error fetching P12:", err);
                        navigate('/lobby');
                    }
                })();
            } else {
                navigate('/lobby');
            }
        }
        }, [location, navigate, dispatch]);

    return null;
}

export default App;
